module.exports = __webpack_public_path__ + "img/phoneOverlay.1af4af01.png";